module.exports = __webpack_public_path__ + "static/media/imbtc.e7178fe4.svg";